module.exports = __webpack_public_path__ + "img/11.61408641.jpg";